<!--
 * @Author: zwj
 * @Date: 2020-10-21 10:34:52
 * @LastEditTime: 2022-12-14 18:11:38
 * @LastEditors: zwj
-->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-corporate.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style src="./style.scss" lang="scss"></style>

<script>
export default {
  name: 'app',
  metaInfo: {
    title: 'Titleist管理后台',
    titleTemplate: '%s - 管理后台'
  },
  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
  }
}
</script>
<style lang="scss">
.btn-primary {
    border-color: transparent;
    background: #C0191F;
    color: #fff;
    &:hover{
      background: #C0191F;
    }
}

.btn-round {
    border-radius: 60rem !important;
}
#qrcode{
	iframe {
		width: 200px;
		height: 300px;
	}
}
</style>
